
export default {
  name: "InputRequire",
  data() {
    return {
      message: "",
    };
  },
  props: {
    // 控制是否进行校验 1 校验 2 不校验
    status: {
      type: Number,
      default: 1,
    },
    inputParams: {
      type: Object,
      default: {
        type: "",
        label: "",
        value: "",
        require: true,
        showMessage: false,
        message: "Please enter your content",
      },
    },
    rules: {
      type: Array,
      default: [],
    },
  },
  watch: {
    inputParams: {
      deep: true,
      handler(val) {
        if (this.status != 1) return;

        let typeObj = this.rules.find(v => v.type);
        if (typeObj) {
          if (val.value) {
            this.message = typeObj.message;
            return;
          }
          this.message = this.rules[0].message;
        } else {
          this.message = this.rules[0].message;
          if (!val.value) {
            this.$emit("handleShowMessage", {
              ...val,
              showMessage: true,
            });
          } else {
            this.$emit("handleShowMessage", {
              ...val,
              showMessage: false,
            });
          }
        }
      },
    },
  },
};
